import { useContext } from 'react';

import { InventoryCardContext } from '@app/providers/InventoryCardProvider/InventoryCardContext';

export const useInventoryCardContext = () => {
  const context = useContext(InventoryCardContext);

  if (!context) {
    throw new Error(
      'useInventoryCardContext must be used within an InventoryCardProvider'
    );
  }

  return context;
};
